/**
 * Centralized API configuration for Viaggio Ferry Frontend (Company site)
 * Supports dynamic configuration via environment variables exactly like the dashboard site
 */

export const ROOT_API_URL = process.env.REACT_APP_ROOT_API_URL || "http://localhost:3001"
export const API_BASE_URL = `${ROOT_API_URL}/api`
